import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';
import { AuthenticationRootPath } from 'utils/constants/routes';
import FatsomaTabbLogo from 'utils/images/fatsoma-tabb-logo.svg';
import ConfirmResetForm from './ConfirmResetForm';
import CreateVenueForm from './CreateVenueForm';
import './index.scss';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ResetForm from './ResetForm';

class Authentication extends Component {
  componentWillMount() {}

  render() {
    const { token, loading, hasVenues, location } = this.props;

    if (token && !loading && hasVenues) {
      return <Redirect to="/" push />;
    }
    if (
      token &&
      !loading &&
      !hasVenues &&
      location.pathname !== '/auth/create-venue'
    ) {
      return <Redirect to="/auth/create-venue" push />;
    }

    return (
      <div className="auth__full__container">
        <div className="auth__container">
          <div className="auth__logo__nav__bar">
            <img src={FatsomaTabbLogo} alt="Logo" className="auth__logo" />
          </div>

          <div className="auth__page__content">
            <Router>
              <Switch>
                <Route
                  path={`${AuthenticationRootPath}/login`}
                  component={LoginForm}
                />
                <Route
                  path={`${AuthenticationRootPath}/register`}
                  component={RegisterForm}
                />
                <Route
                  path={`${AuthenticationRootPath}/create-venue`}
                  component={CreateVenueForm}
                />
                <Route
                  path={`${AuthenticationRootPath}/reset`}
                  component={ResetForm}
                />
                <Route
                  path={`${AuthenticationRootPath}/confirm-reset`}
                  component={ConfirmResetForm}
                />
              </Switch>
            </Router>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  token: state.authentication.accessToken,
  loading: state.authentication.loading,
  hasVenues: state.authentication.hasVenues,
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(props => <Authentication {...props} />));



// WEBPACK FOOTER //
// ./src/components/Authentication/index.jsx